import React from 'react';
import { connect } from 'react-redux';

import Channel from 'app/tyler/components/rgb/channel';
import Color from 'app/tyler/components/rgb/color';
import Duck    from 'app/tyler/ducks/rgb';

class PageRgb extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onChangeR = this.onChangeR.bind(this);
    this.onChangeG = this.onChangeG.bind(this);
    this.onChangeB = this.onChangeB.bind(this);
    this.onClickRandom = this.onClickRandom.bind(this);
  }

  onChangeR(r) {
    this.props.setR(r);
  }
  onChangeG(g) {
    this.props.setG(g);
  }
  onChangeB(b) {
    this.props.setB(b);
  }

  onClickRandom() {
    this.props.pickRand();
  }

  render() {
    const {r,g,b} = this.props;

    return (
      <div className="rgb">
        <div className="rgb-head">
          <h1>RGB</h1>
          <button className="rgb-head-btn" onClick={this.onClickRandom}>random</button>
        </div>

        <div className="rgb-layout">
          <div className="rgb-left">
            <Channel value={r} onChange={this.onChangeR} color="red" />
            <Channel value={g} onChange={this.onChangeG} color="green" />
            <Channel value={b} onChange={this.onChangeB} color="blue" />
          </div>

          <div className="rgb-right">
            <Color r={r} g={g} b={b} />
          </div>
        </div>

      </div>
    );
  }

}

const stateToProps = (state) => ({
  r: Duck.Slx.r(state),
  g: Duck.Slx.g(state),
  b: Duck.Slx.b(state),
});

const dispatchToProps = (dispatch) => ({
  setR: (r) => dispatch(Duck.Ax.setR(r)),
  setG: (g) => dispatch(Duck.Ax.setG(g)),
  setB: (b) => dispatch(Duck.Ax.setB(b)),
  pickRand: () => dispatch(Duck.Ax.pickRand()),
});

export default connect(stateToProps, dispatchToProps)(PageRgb);
